enum ButtonColorsEnum {
    Primary = 'primary',
    Secondary = 'secondary',
    Red = 'red',
    White = 'white',
    Dark = 'dark',
}

export default ButtonColorsEnum;
